import { Link } from 'react-router-dom';

export default function Footer() {
    return (
        <footer className="py-20 border-t border-white/[0.05] bg-black relative z-10">
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
                    <div className="col-span-1 md:col-span-1">
                        <div className="flex items-center gap-2 mb-6">
                            <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                                <i className="ri-robot-line text-lg text-black"></i>
                            </div>
                            <span className="text-lg font-bold text-white">PitchMe.AI</span>
                        </div>
                        <p className="text-zinc-500 text-sm leading-relaxed">
                            Advanced AI-powered interview coaching platform to help professionals land their dream jobs.
                        </p>
                    </div>

                    <div>
                        <h4 className="font-bold text-white mb-6">Platform</h4>
                        <ul className="space-y-4 text-sm text-zinc-500">
                            <li><Link to="#" className="hover:text-white transition-colors">Features</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">Pricing</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">Testimonials</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">FAQ</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold text-white mb-6">Company</h4>
                        <ul className="space-y-4 text-sm text-zinc-500">
                            <li><Link to="#" className="hover:text-white transition-colors">About Us</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">Careers</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">Blog</Link></li>
                            <li><Link to="#" className="hover:text-white transition-colors">Contact</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-bold text-white mb-6">Connect</h4>
                        <div className="flex gap-4">
                            <a href="#" className="w-10 h-10 rounded-full bg-white/[0.05] flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/[0.1] transition-all">
                                <i className="ri-twitter-x-line"></i>
                            </a>
                            <a href="#" className="w-10 h-10 rounded-full bg-white/[0.05] flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/[0.1] transition-all">
                                <i className="ri-linkedin-fill"></i>
                            </a>
                            <a href="#" className="w-10 h-10 rounded-full bg-white/[0.05] flex items-center justify-center text-zinc-400 hover:text-white hover:bg-white/[0.1] transition-all">
                                <i className="ri-instagram-line"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="pt-8 border-t border-white/[0.05] flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-zinc-600 text-sm">© 2025 PitchMe.AI. All rights reserved.</p>
                    <div className="flex gap-8 text-sm text-zinc-600">
                        <Link to="#" className="hover:text-zinc-400">Privacy Policy</Link>
                        <Link to="#" className="hover:text-zinc-400">Terms of Service</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
